var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotFoundinline = function SvgNotFoundinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 16,
    x: 28,
    y: 52,
    fill: "#EBFBFF",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 16,
    x: 61,
    y: 36,
    fill: "#EBFBFF",
    rx: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 16,
    x: 39,
    y: 68,
    fill: "#EBFBFF",
    rx: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 16,
    y: 84,
    fill: "#EBFBFF",
    rx: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 16,
    x: 39,
    y: 100,
    fill: "#EBFBFF",
    rx: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 16,
    x: 23,
    y: 116,
    fill: "#EBFBFF",
    rx: 8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 16,
    x: 48,
    y: 132,
    fill: "#EBFBFF",
    rx: 8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 16,
    x: 67,
    y: 148,
    fill: "#EBFBFF",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B4D5",
    fillRule: "evenodd",
    d: "M141 62a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF0F7",
    fillRule: "evenodd",
    d: "M184 94a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM18 77a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B4D5",
    fillRule: "evenodd",
    d: "M83 148a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF0F7",
    fillRule: "evenodd",
    d: "M91.485 25.172a1 1 0 0 0-1.415 0l-1.414 1.414-1.414-1.414a1 1 0 0 0-1.414 1.414L87.242 28l-1.414 1.414a1 1 0 0 0 1.414 1.414l1.414-1.414 1.414 1.414a1 1 0 1 0 1.415-1.414L90.07 28l1.415-1.414a1 1 0 0 0 0-1.414Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B4D5",
    d: "M56.02 59c.9 0 1.62.224 2.16.673.546.448.82 1.081.82 1.898 0 .753-.261 1.342-.783 1.767-.514.416-1.195.629-2.046.637l-.063.9h-1.894l-.063-2.234h.758c.648 0 1.14-.076 1.477-.228.345-.153.518-.429.518-.83 0-.28-.08-.5-.24-.66-.16-.16-.383-.24-.67-.24-.303 0-.538.083-.707.252-.168.16-.252.38-.252.66h-2.033a2.416 2.416 0 0 1 .315-1.321 2.414 2.414 0 0 1 1.036-.925c.463-.233 1.019-.349 1.667-.349Zm-.834 9c-.379 0-.69-.104-.934-.312a1.036 1.036 0 0 1-.354-.794c0-.32.118-.588.354-.805.244-.216.555-.324.934-.324.37 0 .674.108.91.325.244.216.366.484.366.804 0 .313-.122.577-.366.794-.236.208-.54.312-.91.312Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF0F7",
    d: "M107.02 169c.901 0 1.62.224 2.159.673.547.448.821 1.081.821 1.898 0 .753-.261 1.342-.783 1.767-.513.416-1.195.629-2.046.637l-.063.901h-1.894l-.063-2.235h.758c.648 0 1.14-.076 1.477-.228.345-.153.518-.429.518-.83 0-.28-.08-.5-.24-.66-.16-.161-.383-.241-.669-.241-.304 0-.539.084-.708.253-.168.16-.252.38-.252.66h-2.033a2.416 2.416 0 0 1 .315-1.321c.236-.393.581-.701 1.036-.926.463-.232 1.019-.348 1.667-.348Zm-.834 9c-.378 0-.69-.104-.934-.312a1.036 1.036 0 0 1-.354-.793c0-.321.118-.589.354-.806.244-.216.556-.324.934-.324.371 0 .674.108.91.324.244.217.366.485.366.806 0 .312-.122.576-.366.793-.236.208-.539.312-.91.312Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B4D5",
    d: "M158.02 103c.901 0 1.62.224 2.159.673.547.448.821 1.081.821 1.898 0 .753-.261 1.342-.783 1.767-.513.416-1.195.629-2.046.637l-.063.901h-1.894l-.063-2.235h.758c.648 0 1.14-.076 1.477-.228.345-.153.518-.429.518-.83 0-.28-.08-.5-.24-.66-.16-.161-.383-.241-.669-.241-.304 0-.539.084-.708.253-.168.16-.252.38-.252.66h-2.033a2.416 2.416 0 0 1 .315-1.321c.236-.393.581-.701 1.036-.926.463-.232 1.019-.348 1.667-.348Zm-.834 9c-.378 0-.69-.104-.934-.312a1.036 1.036 0 0 1-.354-.793c0-.321.118-.589.354-.806.244-.216.556-.324.934-.324.371 0 .674.108.91.324.244.217.366.485.366.806 0 .312-.122.576-.366.793-.236.208-.539.312-.91.312Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF0F7",
    fillRule: "evenodd",
    d: "M25.172 105.172a1 1 0 0 0 0 1.414L26.586 108l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.415-1.414 1.414 1.414a1 1 0 1 0 1.414-1.414L29.415 108l1.414-1.414a1 1 0 1 0-1.414-1.414L28 106.586l-1.415-1.414a1 1 0 0 0-1.414 0Zm142.656 32a.999.999 0 0 0-1.414 0L165 138.586l-1.414-1.414a.999.999 0 1 0-1.414 1.414l1.414 1.414-1.414 1.414a1 1 0 1 0 1.414 1.415l1.414-1.415 1.414 1.415a1 1 0 0 0 1.414-1.415L166.414 140l1.414-1.414a.999.999 0 0 0 0-1.414Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B4D5",
    fillRule: "evenodd",
    d: "M73 73a8 8 0 0 0-8 8v3h70v-3a8 8 0 0 0-8-8H73Zm-8 45V86h70v32a8 8 0 0 1-8 8H73a8 8 0 0 1-8-8Zm30.47-12.537c0-1.693.31-3.027.93-4.001.628-.975 1.637-1.462 3.025-1.462 1.389 0 2.393.487 3.013 1.462.629.974.943 2.308.943 4.001 0 1.713-.314 3.056-.943 4.031-.62.974-1.624 1.462-3.013 1.462-1.388 0-2.397-.488-3.026-1.462-.62-.975-.929-2.318-.929-4.031Zm5.546 0c0-.994-.103-1.757-.31-2.289-.206-.541-.633-.812-1.28-.812-.648 0-1.075.271-1.282.812-.206.532-.31 1.295-.31 2.289 0 .669.038 1.226.114 1.669.075.433.225.787.45 1.063.234.265.577.398 1.028.398.45 0 .788-.133 1.013-.398.235-.276.389-.63.465-1.063.075-.443.112-1 .112-1.669ZM86 109.081v-2.038l4.448-6.674h2.689v6.526h1.154v2.186h-1.154V111H90.73v-1.919H86Zm4.899-5.936-2.365 3.75h2.365v-3.75Zm13.81 3.898v2.038h4.73V111h2.407v-1.919H113v-2.186h-1.154v-6.526h-2.689l-4.448 6.674Zm2.534-.148 2.365-3.75v3.75h-2.365ZM117.5 80a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    clipRule: "evenodd"
  })));
};
export default SvgNotFoundinline;